<div class="page-wrapper detail-products-page">
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div>
          <a style="margin-right: 2px;" routerLink="/">Accueil</a><span class="symbol">></span> Catalogue produits
          <span *ngFor="let cateLevel of categoriesLevelList">
            <span class="symbol">></span>
            <a style="margin-right: 2px;" *ngFor="let cate of cateLevel; index as i"
              [routerLink]="['/catalogues', cate?.codeCategory]">
              <span *ngIf="i !== 0 "> - </span>
              {{cate?.nameCategory['fr_FR']}}
            </a>
          </span>

          <span *ngIf="dataDetailProduct?.longDescription"> <span class="symbol">></span> {{
            dataDetailProduct?.longDescription }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="detail-products-page-inner">
    <div class="container">
      <h2 class="title d-flex align-items-center gap-2">
        <span *ngIf="isLoadingCategoryLogo"><mat-spinner [diameter]="14"
            style="display:inline-block;"></mat-spinner>&nbsp;&nbsp;</span>
        <img *ngIf="!isLoadingCategoryLogo"
          [src]="categoryLogoUrl ? categoryLogoUrl : 'src-adisco/assets/images/image-default.jpeg'" alt="category-logo">
        {{ dataDetailProduct?.longDescription }}
      </h2>
    </div>
    <app-general-info *ngIf="!isLoading" [item]="dataDetailProduct" [listUrlImageProduct]="listUrlImageProduct"></app-general-info>
    <app-detail-info *ngIf="!isLoading" [item]="dataDetailProduct" [listUrlImageProduct]="listUrlImageProduct"></app-detail-info>
    <div *ngIf="dataDetailProduct?.associatedProduct && dataDetailProduct?.associatedProduct.length > 0"
      class="affiliate-products py-5">
      <div class="container">
        <p class="title text-center">PRODUITS ASSOCIÉS</p>
        <app-slide-product *ngIf="!isLoading" [item]="listIdAssociatedProduct"></app-slide-product>
      </div>
    </div>
    <div *ngIf="listIdDispenserForUseWithProduct && listIdDispenserForUseWithProduct.length > 0"
      class="associated-distributors py-5">
      <div class="container">
        <p class="title text-center">DISTRIBUTEURS ASSOCIÉS</p>
        <app-slide-product *ngIf="!isLoading" [item]="listIdDispenserForUseWithProduct"></app-slide-product>
      </div>
    </div>

    <div *ngIf="listIdDilutionProduct && listIdDilutionProduct.length > 0" class="associated-distributors py-5">
      <div class="container">
        <p class="title text-center">SYSTÈME DE DILUTION</p>
        <app-slide-product *ngIf="!isLoading" [item]="listIdDilutionProduct"></app-slide-product>
      </div>
    </div>
  </div>
</div>